import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'cursor-tracker',
    description:
      'Track Cursor usage, estimated hours saved, and net ROI across projects.',
    icon: 'thunder',
    name: 'Cursor Tracker',
    scenarioVariables: [],
    sessionVariables: [],
    supportsScenarios: false,
  },
  type: core.quiver.Resource.Type.App,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.App>
